export const IconYoutube20: {
  name: 'icon_youtube_20-7b27230e2130'
} = {
  name: 'icon_youtube_20-7b27230e2130'
}
